<script>
  import { createEventDispatcher, onMount } from "svelte";
  import * as Hotkeys from "../util/hotkeys.js";
  import { get } from "svelte/store";

  const dispatch = createEventDispatcher();

  export let enabled = true;
  export let radio = false;
  export let text = "";
  export let alt = text;
  export let state = 0;
  export let toggled = false;
  export let publish = false;
  export let small = false;
  export let xsmall = false;
  export let hotkey = null;
  export let showHotkey = false;
  export let tab = false;
  export let tabShadow = false;
  export let active = false;
  export let icon = null;
  export let fileInput = false;
  export let hideLeftBorderOnMobile = false;
  export let hideOnMobile = false;
  export let square = false;
  export let ignoreClick = false;
  export let flip = false;
  export let fitHeight = false;
  export let galleryToolbar = false;
  export let bigger = false;

  const component = "button";

  let isHotkeyEnabled;
  const unsubHotkeys = Hotkeys.getEnabledStore().subscribe((v) => {
    isHotkeyEnabled = v;
  });

  let down;

  let formatted = getFormattedTextHTML();
  let iconAndText;
  $: hotkey,
    text,
    showHotkey,
    isHotkeyEnabled,
    (formatted = getFormattedTextHTML()),
    (iconAndText = Boolean(text && icon));

  let downTimer;
  onMount(() => {
    let unsub = Hotkeys.mount(hotkey, trigger);
    return () => {
      unsub();
      unsubHotkeys();
      clearTimeout(downTimer);
    };
  });

  function getFormattedTextHTML() {
    const curText = (text || "").trim();
    const idx = hotkey
      ? curText.toLowerCase().indexOf(hotkey.toLowerCase())
      : -1;
    if (curText && showHotkey && isHotkeyEnabled && hotkey && idx >= 0) {
      if (/[\<\>\:]/g.test(curText)) {
        console.log("Ignoring text due to invalid characters:", curText);
        return { text: curText };
      } else {
        const first = curText.slice(0, idx);
        const mid = curText.slice(idx, idx + 1);
        const last = curText.slice(idx + 1);
        return {
          html: [first, `<u class='hotkey-underline'>${mid}</u>`, last].join(
            ""
          ),
        };
      }
    } else {
      return { text: curText };
    }
  }

  function click(ev) {
    if (!ignoreClick) {
      ev.preventDefault();
      trigger(ev);
    }
  }

  function trigger(ev) {
    if (!enabled) return;

    let value = toggled;
    if (radio == "three") {
      state += 1;
      state = state % 3;
      value = state === 1; // not sure what to do for this?
    } else if (radio) {
      toggled = !toggled;
      value = toggled;
    }

    dispatch("click", { originalEvent: ev, toggled: value, state });
  }
</script>

{#if !fileInput}
  <button
    class:small
    class:hideOnMobile
    class:publish
    class:toggled
    class:down
    class:tab
    class:hideLeftBorderOnMobile
    class:active
    class:tabShadow
    class:xsmall
    class:iconAndText
    class:galleryToolbar
    class:fitHeight
    class:square
    class:flip
    class:bigger
    class:baseButton={true}
    class:noselect={true}
    class={radio === "three" ? `radio-three-${state}` : ""}
    class:disabled={!enabled}
    {enabled}
    title={hotkey ? `${alt} (${hotkey.toUpperCase()})` : alt}
    on:focus
    on:mouseover
    on:mouseenter
    on:click={click}
  >
    {#if formatted && formatted.html}
      {@html formatted.html}
    {:else if formatted}
      {formatted.text}
    {/if}
    {#if icon}
      {#if typeof icon === "string"}
        <img src={icon} alt={null} />
      {:else}
        <svelte:component this={icon} />
      {/if}
    {/if}
  </button>
{:else}
  <label
    class="file-button"
    class:small
    class:hideOnMobile
    class:baseButton={true}
    class:noselect={true}
    class:publish
    class:toggled
    class:down
    class:tab
    class:active
    class:tabShadow
    class:xsmall
    class:disabled={!enabled}
    title={hotkey ? `${alt} (${hotkey.toUpperCase()})` : alt}
  >
    <input
      type="file"
      {enabled}
      on:input={(ev) => {
        dispatch("select", {
          files: ev.target.files,
          reset() {
            ev.target.value = "";
          },
        });
      }}
    />
    {#if formatted && formatted.html}
      {@html formatted.html}
    {:else if formatted}
      {formatted.text}
    {/if}
  </label>
{/if}

<!-- <svelte:window on:keydown|nonpassive={keydown} /> -->

<style>
  input[type="file"] {
    display: none;
  }
  button,
  label {
    --color: #000;
    --shadow-color: black;
    --background: white;
    --down-background: hsl(0, 0%, 85%);
    position: relative;
    font: inherit;
    color: var(--color);
    margin: 0;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    padding: 10px 20px;
    appearance: none;
    border: 1px solid var(--shadow-color);
    background: white;
    box-sizing: border-box;
    border-radius: 33px;
    /* min-width: 50px; */
    text-transform: uppercase;

    box-shadow: 2px 2px 0 var(--shadow-color);
    cursor: pointer;
    outline: 0;
    /* height: 38px; */
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  button img,
  :global(.baseButton svg) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    /* height: 100%; */
    /* width: 100%; */
    height: 100%;
    width: 16px;
    /* min-width: 14px; */
    min-height: 16px;
    box-sizing: border-box;
    line-height: 1;
    vertical-align: middle;
  }
  .flip img,
  :global(.flip svg) {
    transform: scale(-1, 1);
  }
  label {
    /* display: inline-block; */
    line-height: 1.2;
    vertical-align: middle;
    display: inline-block;
  }
  button {
    line-height: 1.2;
  }
  .publish {
    --color: white;
    --background: green;
    background: var(--background);
    border-color: var(--shadow-color);
  }
  .iconAndText img,
  :global(.iconAndText svg) {
    height: 100%;
    width: 16px;
    margin-left: 5px;
    /* margin-right: 0; */
    /* padding-right: 0; */
  }
  /* :active,
  .down {
    background: var(--down-background);
  } */
  .square {
    /* background: hsl(0, 0%, 85%); */
    /* background: white; */
    /* background: none; */
  }
  .toggled {
    background: var(--accent-color);
  }
  .small {
    padding: 5px 15px;
  }
  .xsmall {
    font-size: 11px;
    padding: 2.5px 10px;
  }
  .square {
    padding: 10px;
    /* width: 28px;
    height: 28px;
    box-sizing: border-box; */
    /* border-radius: 2px; */
    /* background: none; */
    /* box-shadow: none; */
    /* border: none; */
    /* border: 1px solid var(--shadow-color); */
    /* box-shadow:
      0px 2px 0px var(--shadow-color),
      2px 0px 0px var(--shadow-color),
      2px 2px 0px var(--shadow-color);

    border: 1px solid black;
    border-radius: 0;
    appearance: none;
    margin: 0; */
  }
  .galleryToolbar {
    height: var(--gallery-toolbar-height);
    width: var(--gallery-toolbar-height);
    border-radius: 0;
    border: 0;
    box-shadow: none;
  }
  .fitHeight {
    height: 100%;
  }

  .tab {
    --border-color: black;

    appearance: none;
    border: 0;
    background: white;
    border-radius: 0;
    text-transform: initial;

    box-shadow: none;
    cursor: pointer;
    outline: 0;
    overflow: visible;

    appearance: none;
    border: 0;
    background: none;
    padding: 0;
    border: 1px solid var(--border-color);
    border-bottom: 0;
    border-right: 0;
    border-radius: 0;
    box-sizing: border-box;
    padding: 5px 10px;
    position: relative;
    /* border-bottom: 1px solid black; */
  }
  .tab.active::after {
    content: " ";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background: var(--accent-color);
  }
  .tab.active {
    /* background: white; */
    background: var(--accent-color);
    /* border-bottom: 1px solid white; */
  }
  .tab.tabShadow {
    border-right: 1px solid var(--border-color);
    box-shadow: 3px 0 0 var(--border-color);
  }
  .radio-three-0 {
  }
  .radio-three-1::after {
    background: var(--accent-color);

    /* background: rgba(var(--accent-color), 0.5); */
    width: 100%;
    height: 100%;
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: -1;
    border-radius: inherit;
    box-sizing: border-box;
    border: 4px solid white;

    /* border-left: 20px solid white; */
    /* border-right: 100px solid #f0e5aa; */
  }
  .radio-three-1 {
    background: transparent;
  }
  .radio-three-2 {
    background: var(--accent-color);
  }
  .disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .bigger {
    padding: 15px 30px;
    /* min-width: 260px; */
  }
  /* .disabled::after {
    background-color: rgba(255, 255, 255, 0.5);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: " ";
    border-radius: 33px;
  } */

  @media screen and (max-width: 500px) {
    .hideOnMobile {
      display: none;
    }
  }

  @media screen and (max-width: 720px) {
    .hideLeftBorderOnMobile {
      border-left: 0;
    }

    .bigger {
      padding: 10px 20px;
      min-width: initial;
    }
  }

  @media screen and (max-width: 900px) {
    button,
    label {
      /* padding: 5px 15px; */
    }
  }
</style>
